import { createMulticastServiceType } from '@tv2-player/service-container/src/serviceContainer';

/**
 * An interface that can be implemented to handle overseer messages
 */
export const OverseerMessageHandler = createMulticastServiceType<OverseerMessageHandlerInterface>();
export interface OverseerMessageHandlerInterface {
  sessionId: string;
  hasSession: boolean;
  trackPluginCall(session: string, plugin: string, name: string, value?: any, metadata?: any): void;
  createSession(session: string): void;
  setMetadata(metadata: Record<string, any>): void;
}

export abstract class OverseerMessageHandlerClass implements OverseerMessageHandlerInterface {
  enabled: boolean = false;
  hasSession: boolean = false;
  sessionId: string = '';

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

  createSession(session: string): void {
    if (this.hasSession) return;

    this.sessionId = session;
    this.hasSession = true;
  }

  abstract setMetadata(metadata: Record<string, any>): void;

  abstract trackPluginCall(plugin: string, name: string, value?: any, metadata?: any): void;
}
